import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { loadFailure, loadRequestProdutos, loadSuccess } from './actions';

export function* loadProdutos({ payload }: ReturnType<typeof loadRequestProdutos>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getProdutos&token=${state.auth.token}`,
      { inscricoesEstaduais: payload.inscricaoAtiva, centroDistribuicao: payload.cddAtivo }
    );
    yield put(loadSuccess(response.data.produtos));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar os produtos, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
